// extracted by mini-css-extract-plugin
export default {"baseOrange":"#ff7800","baseGreen":"#5cb85c"};